import {
    FETCH_DISCOUNT_CODES,
    FETCH_DISCOUNT_CODES_FAILURE,
    FETCH_DISCOUNT_CODES_SUCCESS,

    FETCH_DISCOUNT_CODE,
    FETCH_DISCOUNT_CODE_FAILURE,
    FETCH_DISCOUNT_CODE_SUCCESS,
} from 'store/actions/types';
import utils from 'helpers/utils';

export const fetchDiscountCodes = (payload) => {
    payload = payload || {};

    let params = {
        size: payload.size ? payload.size : 12,
        sort_by: payload.field ? payload.field : 'id',
        sort_direction: payload.order ? payload.order.toLowerCase() : 'asc',
    };

    if (!payload.offset && payload.page) {
        params.offset = (payload.page - 1) * params.size;
    }

    if (!utils.isEmpty(payload.filter)) {
        const filters = utils.buildFilterObject(payload.filter);

        params = Object.assign({}, params, filters);
    }

    return {
        type: FETCH_DISCOUNT_CODES,
        payload: params,
    };
};

export const fetchDiscountCodesFailure = (error) => {
    return {
        type: FETCH_DISCOUNT_CODES_FAILURE,
        error: error,
    };
};

export const fetchDiscountCodesSuccess = (payload) => {
    return {
        type: FETCH_DISCOUNT_CODES_SUCCESS,
        payload: payload,
    };
};

export const fetchDiscountCode = (payload) => {
    return {
        type: FETCH_DISCOUNT_CODE,
        payload: payload,
    };
};

export const fetchDiscountCodeFailure = (error) => {
    return {
        type: FETCH_DISCOUNT_CODE_FAILURE,
        error: error,
    };
};

export const fetchDiscountCodeSuccess = (response) => {
    return {
        type: FETCH_DISCOUNT_CODE_SUCCESS,
        response: response,
    };
};

export const updateListParams = (payload) => {
    return {
        type: payload.type,
        payload: payload.payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/discountCodes/fetchDiscountCodes.js